// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DefaultNavbar from "devComponents/Navbars/PublicNavbar";
import Contact from "./sections/Contact";
import bgVideo from "assets/background5.mp4";

function index() {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh", 
        overflow: "visible", 
      }}
    >
      <video
        autoPlay
        loop
        src={bgVideo}
        muted

        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          objectFit: "cover",
          zIndex: -2,
        }}
      />
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          zIndex: -1,
        }}
      />
      <Box sx={{ position: "relative", zIndex: 2 }}>
        <DefaultNavbar />
        <Typography
          color="#ffff"
          textAlign="center"
          sx={{
            fontWeight: 400,
            fontSize: { xs: "2rem", md: "3rem" },
            mt: 12,
            background: "linear-gradient(135deg, #ffff, #ffff)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: { xs: "block", md: "block" },
          }}
        >
          Contact Us
        </Typography>
        <Typography
          variant="body2"
          color="#ffff"
          textAlign="center"
          sx={{
            maxWidth: 600,
            mx: "auto",
            display: { xs: "none", md: "block" },
          }}
        >
          Get in touch with our team for any inquiries or support
        </Typography>

        <Contact />
      </Box>
    </Box>
  );
}

export default index;
